<div class="card flex flex-col gap-6 max-w-xl">
    <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
            <div class="font-semibold text-xl">Stripe</div>
            @if (stripe()) {
                <p-tag [value]="enabled() ? 'Enabled' : 'Disabled'" [severity]="enabled() ? 'success' : 'secondary'" />
            }
        </div>
        <p-button
            label="Edit on Companies page"
            icon="pi pi-external-link"
            severity="secondary"
            outlined
            size="small"
            (click)="goToCompanies()"
        />
    </div>

    <p-message severity="info" styleClass="text-sm">
        Stripe credentials are managed at the <strong>Company</strong> level — one Stripe account can serve every website owned by the company. To change keys, edit the parent company.
    </p-message>

    @if (!company()) {
        <p-message severity="warn" styleClass="text-sm">
            Parent company is not loaded. Open the Companies page to verify access.
        </p-message>
    } @else if (!stripe()) {
        <p-message severity="warn" styleClass="text-sm">
            Stripe is not configured for this company yet.
        </p-message>
    } @else {
        <div class="flex flex-col gap-4">
            <div>
                <label class="block font-medium mb-1">Publishable Key</label>
                <div class="flex items-center gap-2">
                    <code class="flex-1 truncate font-mono text-sm px-3 py-2 rounded bg-surface-100 dark:bg-surface-800">{{ stripe()!.PublishableKey || '—' }}</code>
                    @if (stripe()!.PublishableKey) {
                        <p-button
                            [icon]="copiedField() === 'pub' ? 'pi pi-check' : 'pi pi-copy'"
                            severity="secondary"
                            [text]="true"
                            [rounded]="true"
                            size="small"
                            [pTooltip]="copiedField() === 'pub' ? 'Copied' : 'Copy'"
                            (onClick)="copy('pub', stripe()!.PublishableKey)"
                        />
                    }
                </div>
            </div>

            <div>
                <label class="block font-medium mb-1">Secret Key</label>
                <div class="flex items-center gap-2">
                    <code class="flex-1 truncate font-mono text-sm px-3 py-2 rounded bg-surface-100 dark:bg-surface-800">{{ mask(stripe()!.SecretKey) }}</code>
                </div>
                <small class="text-muted-color">Hidden — edit the company to view or rotate.</small>
            </div>

            <div>
                <label class="block font-medium mb-1">Webhook Secret</label>
                <div class="flex items-center gap-2">
                    <code class="flex-1 truncate font-mono text-sm px-3 py-2 rounded bg-surface-100 dark:bg-surface-800">{{ mask(stripe()!.WebhookSecret) }}</code>
                </div>
                <small class="text-muted-color">Used to verify Stripe webhook signatures.</small>
            </div>
        </div>
    }

    <div class="border-t border-surface-200 dark:border-surface-700 pt-4">
        <label class="block font-medium mb-1">Webhook URL</label>
        <div class="flex items-center gap-2">
            <code class="flex-1 truncate font-mono text-sm px-3 py-2 rounded bg-surface-100 dark:bg-surface-800">{{ webhookUrl }}</code>
            <p-button
                [icon]="copiedField() === 'url' ? 'pi pi-check' : 'pi pi-copy'"
                severity="secondary"
                [text]="true"
                [rounded]="true"
                size="small"
                [pTooltip]="copiedField() === 'url' ? 'Copied' : 'Copy'"
                (onClick)="copy('url', webhookUrl)"
            />
        </div>
        <small class="text-muted-color">Paste this URL into your Stripe Dashboard webhook configuration.</small>
    </div>
</div>
